export default __webpack_public_path__ + "static/media/Spinner2.7a9ea915.gif";